
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[id]/exam/[examId]",
      function () {
        return require("private-next-pages/category/[id]/exam/[examId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[id]/exam/[examId]"])
      });
    }
  